import * as React from 'react';

interface NotFoundPageProps {
  title: string;
  description: string;
  subdescription: string;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({ title, description, subdescription }) => (
  <main>
    <h1>{title}</h1>
    <p>{description}</p>
    <p>{subdescription}</p>
  </main>
);
